export default __webpack_public_path__ + "static/media/tequiladrinks.a37e0c96.png";